export default function buildGetProducerSalePoints({
    apiEndpoint,
    apiTools
}) {
    return async function getProducerSalePoints(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/producer`
        })
       
        const res = await fetch(url, {
            method: 'GET',
            credentials: 'include',
        });
        return await res.json();
    }
}